define([
    "models/contact",
    "i18next/i18next",
    "backbone-validation"
    ], function(ContactModel, i18n) {
        "use strict";

        var ContactView = App.View.extend({
            el: ".js-contact-form",

            events: {
                "click .js-btn-contact-form"   : "onClickBtnContactForm",
            },

            bindings: {
                ".js-txt-name"    : "value:name",
                ".js-txt-email"   : "value:email",
                ".js-txt-address" : "value:address",
                ".js-txt-phone"   : "value:phone",
                ".js-txt-company" : "value:company",
                ".js-txt-comment" : "value:comment",
                ".js-txt-contact" : "value:contact",
                ".js-txt-sector"  : "value:sector",
                ".js-rb-employees": "radio:employees",
                ".js-chk-accept_contact_conditions .js-checkbox-input" : "checked:accept_contact_conditions"
            },

            validAttributes: [ "name", "email", "phone", "company", "accept_contact_conditions", "landing" ],

            initialize: function(options) {
                this.options = options || {};

                this.model = new ContactModel({
                    landing: this.options.landing
                });
                Backbone.Validation.bind(this);
            },

            setValidAttributes: function(attributes) {
                this.validAttributes = attributes.slice(0);
            },

            onClickBtnContactForm: function() {
                var button = this.buttons[ "btn-send-contact" ]
                var dataset = button.el.dataset
                if (this.model.isValid(this.validAttributes)) {
                    button.showLoading();
                    grecaptcha.ready(function() {
                        grecaptcha.execute(dataset.sitekey, {action: dataset.action}).then(function(token) {
                            this.model.set('reCaptcha', token);
                            this.model.save({}, {
                                success: function() {
                                    App.Noti.show(i18n.t("contact.send_success"), "success", i18n.t("contact.thanks"));
                                    this.model.set({
                                        name    : "",
                                        email   : "",
                                        company : "",
                                        phone   : "",
                                        address : "",
                                        contact : "",
                                        sector : "",
                                        comment : "",
                                    });
                                    this.trigger("contact-form:sent-ok");
                                }.bind(this),
                                error: function(_model, response) {
                                    this.setErrors(response.responseJSON.errors);
                                }.bind(this),
                                complete: function() {
                                    this.buttons[ "btn-send-contact" ].hideLoading();
                                }.bind(this)
                            });
                        }.bind(this))
                    }.bind(this))
                }
            },

        });

        return ContactView;
    });
